import { __rest } from '../../_virtual/_tslib.js';
import React from 'react';
import PropTypes from 'prop-types';

function toPercent(num) {
  return `${num}%`;
}
function Flex(_a) {
  var {
      children,
      className,
      direction,
      count,
      offset,
      style,
      wrap
    } = _a,
    otherProps = __rest(_a, ["children", "className", "direction", "count", "offset", "style", "wrap"]);
  return React.createElement("div", Object.assign({
    className: className,
    style: Object.assign({
      display: 'flex',
      flexDirection: direction,
      flexWrap: wrap ? 'wrap' : 'no-wrap'
    }, style)
  }, otherProps), React.Children.map(children, (child, index) => React.cloneElement(child, Object.assign(Object.assign({}, child.props), {
    style: {
      flexBasis: toPercent(100 / count),
      maxWidth: toPercent(100 / count),
      overflow: 'hidden',
      marginLeft: offset && index === 0 ? toPercent(100 * offset / count) : null
    }
  }))));
}
Flex.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  count: PropTypes.number.isRequired,
  direction: PropTypes.string,
  offset: PropTypes.number,
  style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  wrap: PropTypes.bool
};

export { Flex as default };
